import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class BusinessDashboardProvider {
 	url: any;
 	token: any;
  		
	currentNumbers: any = {
		generatedByStamps: 0,
		redeemedInRewards: 0,
		customersPinned: 0,
	};

	topCards: any = [];
	topCustomers: any = [];

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
       ) {
		console.log('Hello BusinessDashboardProvider Provider');
	}

	getConsumerData(params){	
	  	this.url = this.globals.dataUrl + 'stats/customerNumbersV2';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		    	this.currentNumbers = res.Data;

		        if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

	getTopCards(params){	
	  	this.url = this.globals.dataUrl + 'stats/topCards';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		    	this.topCards = res.Data;

		        if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}  	

	getTopCustomers(params){	
	  	this.url = this.globals.dataUrl + 'stats/topCustomers';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		    	this.topCustomers = res.Data;

		        if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}  	  	
}



// WEBPACK FOOTER //
// ./src/providers/business-dashboard.ts